import React from 'react';
import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

const BaseButton = styled.button`
  background-color: ${COLORS.WHITE};
  color: ${COLORS.REBRAND_DARK};
  height: 64px;
  border-radius: 36px;
  padding: 0 28px;
  font-family: 'Aeonik', Roboto, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 600;
  border: 1px solid #d0d7de;
  display: inline-flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  cursor: pointer;
  transition: 0.2s all;

  @media (max-width: 1024px) {
    align-self: center;
  }

  &:hover {
    background-color: #f7f9fb;
    border-color: #b8c2cc;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const MicrosoftLogo = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="1" y="1" width="10" height="10" fill="#f25022" />
    <rect x="13" y="1" width="10" height="10" fill="#7fba00" />
    <rect x="1" y="13" width="10" height="10" fill="#00a4ef" />
    <rect x="13" y="13" width="10" height="10" fill="#ffb900" />
  </svg>
);

interface NLIMicrosoftButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
}

export const NLIMicrosoftButton: React.FC<NLIMicrosoftButtonProps> = ({
  label = 'CONTINUE WITH MICROSOFT',
  ...rest
}) => {
  return (
    <BaseButton {...rest}>
      <MicrosoftLogo />
      <span>{label}</span>
    </BaseButton>
  );
};
